export { default as UserAccessTable } from './UserAccessTable';
